var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_861",
    "data-name": "Grupo 861",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.94,
    height: 60.94,
    viewBox: "0 0 60.94 60.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_163",
    "data-name": "Elipse 163",
    cx: 30.47,
    cy: 30.47,
    r: 30.47,
    transform: "translate(0)",
    fill: "#b6b6b6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1212",
    "data-name": "Grupo 1212",
    transform: "translate(16.47 16.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "credit_card_FILL0_wght400_GRAD0_opsz48",
    d: "M31.136,8.372v18.2a2.153,2.153,0,0,1-2.1,2.1H5.236a2.015,2.015,0,0,1-1.47-.63,2.015,2.015,0,0,1-.63-1.47V8.372a2.015,2.015,0,0,1,.63-1.47,2.015,2.015,0,0,1,1.47-.63h23.8a2.153,2.153,0,0,1,2.1,2.1Zm-25.9,3.815h23.8V8.372H5.236Zm0,4.515v9.87h23.8V16.7Zm0,9.87v0Z",
    transform: "translate(-3.136 -3.567)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCard);
export default __webpack_public_path__ + "static/media/default-card.61d4b2a28abaf07e61ab2854d6fbdcba.svg";
export { ForwardRef as ReactComponent };